import { render } from "./Door.vue?vue&type=template&id=22711520&scoped=true"
import script from "./Door.vue?vue&type=script&lang=js"
export * from "./Door.vue?vue&type=script&lang=js"

import "./Door.vue?vue&type=style&index=0&id=22711520&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\Сurrent_Projects\\inter-qr\\web-updates\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22711520"]])

export default __exports__